import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { BarChart, BarChartOrientation, BarChartVariant, Heading, HeadingLevel, HeadingTag, Toast, ToastState } from '@enbw/ui-react'
import styles from './styles.module.scss'

export const OperationsPage: FC = () => {
  const { t } = useTranslation()

  const labels = [t('operations.orderCreated'), t('operations.personalDataAdded'), t('operations.paymentMethodAdded'), t('operations.orderConfirmed')]
  const datasets = [
    {
      label: t('operations.last30Days'),
      data: [62000, 51000, 41000, 35000]
    }
  ]

  return (
    <div className={styles.container}>
      <Toast description={t('operations.developerOnlyNotice')} state={ToastState.Info}></Toast>

      <Heading level={HeadingLevel.H1} tag={HeadingTag.H1}>
        {t('operations.title')}
      </Heading>

      <div className={styles.chartHeading}>
        <Heading level={HeadingLevel.H2} tag={HeadingTag.H2}>
          {t('operations.chartTitle')}
        </Heading>
      </div>
      <div className={styles.chartContainer}>
        <BarChart
          label={t('operations.chartTitle')}
          orientation={BarChartOrientation.Horizontal}
          variant={BarChartVariant.Default}
          labels={labels}
          datasets={datasets}
        ></BarChart>
      </div>
    </div>
  )
}
